import ArtifactGroupType from "../base/ArtifactGroupType";


const QueenArwaDinar = {
  id: '155',
  name: "Queen Arwa's Dinar",
  groupIcon: 'PathsOfIncense',
  type: ArtifactGroupType.PATH_OF_INCENSE,
  icon: 'QueenArwaDinar',
  power: 50,
  gameId: 'QueenArwaDinar'
};

export default QueenArwaDinar;
